import {
  composeValidators,
  combineValidators,
  isRequired,
  matchesField,
} from 'revalidate';
import { hasMinimumLength } from 'helpers/validators';

export const fieldsLabels = {
  password: 'New Password',
  passwordConfirmation: 'Password Confirmation',
};

export default combineValidators({
  password: composeValidators(
    isRequired,
    hasMinimumLength(6)
  )(fieldsLabels.password),
  passwordConfirmation: matchesField('password', fieldsLabels.password)(fieldsLabels.passwordConfirmation),
});
